var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDeliveryPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 367 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#dfe5ed;opacity:0.2;}.cls-3,.cls-8{isolation:isolate;}.cls-4,.cls-8{fill:#e7e7e7;}.cls-5{fill:#efefef;}.cls-6{fill:#f2f2f2;}.cls-7,.cls-8{opacity:0.8;}.cls-9{fill:#ddd;}.cls-10{fill:#00c956;}.cls-11{fill:#7e8e9a;}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:#fff;}.cls-14{fill:#ea5e53;}.cls-15{fill:#ebeced;}.cls-16{fill:#e3e4e5;}.cls-17{fill:#dbdbdb;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 367,
    height: 150
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 98.87,
    y1: 111.34,
    x2: 316.4,
    y2: 111.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0.14, 174.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8e9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0d6da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.86,109.93c0,.66,0,1.33-.07,2s-.06,1.3-.11,2a79.08,79.08,0,0,1-1,8.12c-.14.78-.27,1.54-.42,2.28,0,.18-.07.35-.1.52l0,.1c-.09.46-.19.91-.28,1.37-.18.81-.37,1.61-.57,2.38,0,.15-.07.29-.1.44q-.78,3.06-1.67,5.76c-.1.3-.19.6-.29.9-.26.79-.52,1.54-.78,2.28-.19.53-.39,1-.56,1.52-1,2.64-2,4.83-2.75,6.5s-1.33,2.82-1.65,3.48l-.22.45L75.36,150H21.51a0,0,0,0,0,0,0c-.19-.15-.37-.29-.54-.44h0a1.45,1.45,0,0,1-.23-.19l-4-4.29a19.2,19.2,0,0,1-2.13-3.93A21.56,21.56,0,0,1,13,132.9c0-.14,0-.29,0-.44s0-.54,0-.79,0-.46,0-.69c.07-.84.16-1.69.29-2.53,0,0,0,0,0-.08s.05-.29.07-.44.07-.35.11-.53c.12-.63.27-1.25.44-1.89,0-.15.07-.3.1-.45s.1-.35.17-.53c.15-.56.34-1.11.53-1.69.37-1.09.81-2.18,1.3-3.28l.11-.27c.45-1,.94-2,1.47-3,.81-1.49,1.72-3,2.72-4.45.22-.31.43-.63.65-.93a53.41,53.41,0,0,1,3.65-4.61A67.73,67.73,0,0,1,30,100.94c.42-.4.84-.78,1.27-1.16l.29-.26c.25-.2.49-.42.74-.63,1-.9,2-1.74,3-2.56l1.49-1.2,2.81-2.27A48.45,48.45,0,0,0,46.79,86a21.12,21.12,0,0,0,1.8-2.56,19.39,19.39,0,0,0,2.21-5.36c.11-.5.22-1,.3-1.55a24.34,24.34,0,0,0,.33-4.73,38.92,38.92,0,0,0-.33-4.36Q51,67,51,66.46a62.2,62.2,0,0,0-1.31-6.28c-.16-.64-.34-1.3-.53-2-.33-1.16-.59-2.3-.79-3.41a32.64,32.64,0,0,1-.54-6.28,29.12,29.12,0,0,1,.54-5.34v0a31.94,31.94,0,0,1,1.27-4.73c6.54-18.54,28.8-29.5,34.7-31.95C92.72,3,102.69,1,113.06.3L115.6.15C118,0,120.4,0,122.81,0c1,0,2,0,2.92,0,1.63,0,3.24.1,4.86.19s3,.18,4.48.3a148.69,148.69,0,0,1,17.79,2.56A96.9,96.9,0,0,1,166.71,7h0A77.9,77.9,0,0,1,190,20.33c1.38,1.14,2.69,2.3,3.92,3.45l.51.48c.38.35.75.7,1.12,1.07l.51.49c1.08,1.08,2.11,2.16,3.1,3.2l1.46,1.57c2.59,2.87,4.88,5.53,7.07,7.83.27.3.55.57.82.86,3.76,3.8,7.23,6.4,11.49,6.68a37.79,37.79,0,0,0,9.31-1c.35-.07.7-.13,1.06-.22A169,169,0,0,1,249,41.55a58.29,58.29,0,0,1,30.22,4.81l1,.49c1.62.78,3.24,1.64,4.88,2.6l1,.59c1.67,1,3.37,2.16,5.07,3.41a.35.35,0,0,1,.12.1c.74.53,1.48,1.1,2.21,1.68s1.74,1.4,2.61,2.14c2.1,1.81,4.25,3.8,6.39,6a63.57,63.57,0,0,1,4.31,4.83c.92,1.12,1.78,2.25,2.57,3.38l.44.61a69.23,69.23,0,0,1,3.68,6c.13.24.26.51.4.75a61.38,61.38,0,0,1,3.56,8.43c.08.25.17.47.25.71.41,1.27.76,2.53,1.09,3.8.43,1.73.79,3.44,1.08,5.15A70.24,70.24,0,0,1,320.86,109.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.28,43.43v92.93H51.11V76.79a24.24,24.24,0,0,0,.33-4.72,38.92,38.92,0,0,0-.33-4.36V43.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66,43.43v92.93H46.8V86.27a21.93,21.93,0,0,0,1.8-2.56,19.33,19.33,0,0,0,2.21-5.37c.11-.49.22-1,.3-1.55a24.24,24.24,0,0,0,.33-4.72,38.92,38.92,0,0,0-.33-4.36c0-.33-.1-.67-.15-1a62.05,62.05,0,0,0-1.31-6.27c-.16-.64-.34-1.3-.53-2A34.92,34.92,0,0,1,48.33,55a32.48,32.48,0,0,1-.54-6.27,29,29,0,0,1,.54-5.34H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.33,43.43a29,29,0,0,0-.54,5.34H66V43.4H48.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,55v5.38H49.65c-.16-.64-.34-1.3-.53-2-.33-1.16-.59-2.31-.79-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,66.69v5.38H51.44a38.92,38.92,0,0,0-.33-4.36c0-.33-.1-.67-.15-1H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,78.34v5.37H48.6a19.33,19.33,0,0,0,2.21-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,90H46.8v5.37H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,101.64H46.8V107H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,113.29H46.8v5.37H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,124.93H46.8v5.37H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.63,93.08v43.28H20.46V112.09q.33-.48.66-.93a53.41,53.41,0,0,1,3.65-4.61A66,66,0,0,1,30,101.16c.42-.4.84-.78,1.27-1.16l.29-.26c.25-.2.49-.42.74-.63,1-.9,2-1.74,3-2.56l1.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.33,96.56v39.8H16.16V119.77l.11-.27c.44-1,.94-2,1.47-3,.81-1.5,1.72-3,2.71-4.46q.33-.48.66-.93a53.41,53.41,0,0,1,3.65-4.61A66,66,0,0,1,30,101.15c.42-.4.84-.78,1.27-1.16a3.4,3.4,0,0,0,.29-.26c.25-.2.49-.42.74-.63C33.32,98.22,34.33,97.37,35.33,96.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.33,96.56v4.6H30L31.26,100l.29-.26.74-.63C33.32,98.22,34.33,97.37,35.33,96.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.33,106.55v4.62H21.11a53.41,53.41,0,0,1,3.65-4.61H35.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.33,116.54v4.62H16.16v-1.39l.11-.27c.44-1,.94-2,1.47-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.33,126.55H16.16v4.61H35.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.64,133.51h-8v11.67h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190.71,87.12v-7.2h-2.18V67.52H176.75v12.4h-11V59.72H153.62V72.83h-2.77V57.18H138.71V86.53H123.36v17.1h-5.73V108H104.45v-7.42H96.88V80.36H87.54v37.23H78.19V150h121.9V87.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.85,59.17H138.71v3h12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.85,64.78H138.71v3h12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.85,69.84H138.71v3h12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,69.84H153.61v3h12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,64.78H153.61v3h12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,59.73H153.61v3h12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,74.73h-27v3h27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,79.63h-27v3h27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,80.36H87.54V85H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,87.22H87.54v4.61H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,94.08H87.54V98.7H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,101.28H87.54v4.61H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,108.25H87.54v4.61H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,115.22H87.54v4.62H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,122.51H87.54v4.62H97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,84.42h-27v1.9h27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.32,80.36H96.84v20.17h3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.44,100.53h-7V108h7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.17,59.73h-2.42V79.92h2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.33,57.18h-1.48V72.82h1.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.93,89.47h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.77,89.47h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.54,89.47h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.1,89.47h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.74,89.47h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.41,89.47h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.26,89.47h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,89.47H152v2.89H154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.59,89.47h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.22,89.47h-2.05v2.89h2.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165,89.47H163v2.89H165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.86,89.47h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.62,89.47h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.19,89.47h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.83,89.47h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.5,89.47h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.35,89.47h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.11,89.47h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.68,89.47h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.31,89.47h-2.05v2.89h2.05Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.93,94.57h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.77,94.57h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.54,94.57h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.1,94.57h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.74,94.57h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.41,94.57h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.26,94.57h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,94.57H152v2.89H154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.59,94.57h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.22,94.57h-2.05v2.89h2.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165,94.57H163v2.89H165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.86,94.57h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.62,94.57h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.19,94.57h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.83,94.57h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.5,94.57h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.35,94.57h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.11,94.57h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.68,94.57h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.31,94.57h-2.05v2.89h2.05Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.93,99.6h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.77,99.6h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.54,99.6h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.1,99.6h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.74,99.6h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.41,99.6h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.26,99.6h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,99.6H152v2.89H154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.59,99.6h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.22,99.6h-2.05v2.89h2.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165,99.6H163v2.89H165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.86,99.6h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.62,99.6h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.19,99.6h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.83,99.6h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.5,99.6h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.35,99.6h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.11,99.6h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.68,99.6h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.31,99.6h-2.05v2.89h2.05Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.93,104.94h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.77,104.94h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.54,104.94h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.1,104.94h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.74,104.94h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.41,104.94h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.26,104.94h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,104.94H152v2.89H154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.59,104.94h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.22,104.94h-2.05v2.89h2.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165,104.94H163v2.89H165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.86,104.94h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.62,104.94h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.19,104.94h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.83,104.94h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.5,104.94h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.35,104.94h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.11,104.94h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.68,104.94h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.31,104.94h-2.05v2.89h2.05Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.93,110h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.77,110h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.54,110h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.1,110h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.74,110h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.41,110h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.26,110h-2v2.89h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,110H152v2.89H154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.59,110h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.22,110h-2.05v2.89h2.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165,110H163v2.89H165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.86,110h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.62,110h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.19,110h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.83,110h-2.06v2.89h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.5,110h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.35,110h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.11,110h-2.06v2.89h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.68,110h-2.05v2.89h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.31,110h-2.05v2.89h2.05Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.93,115.07h-2.06V118h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.77,115.07h-2.05V118h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.54,115.07h-2.06V118h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.1,115.07h-2V118h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.74,115.07h-2.06V118h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.41,115.07h-2V118h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.26,115.07h-2V118h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,115.07H152V118H154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.59,115.07h-2.05V118h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.22,115.07h-2.05V118h2.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165,115.07H163V118H165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.86,115.07h-2.05V118h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.62,115.07h-2.06V118h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.19,115.07h-2.05V118h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.83,115.07h-2.06V118h2.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.5,115.07h-2.05V118h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.35,115.07h-2.06V118h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.11,115.07h-2.06V118h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.68,115.07h-2.05V118h2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.31,115.07h-2.05V118h2.05Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.13,124.12H111.44v25.66h47.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123,137H75.28v12.82H123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.09,128.12H163v21.66h56.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.51,127.13h-8.89v4.75h8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.92,127.13H126v4.75h8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.11,127.13h-8.89v4.75h8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157.08,127.13H148.2v4.75h8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.22,124.12h-4.58V150h4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.67,78.34h-.25v2h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.58,78.34h-.25v2h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.3,127.62H51.56v22H84.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.3,124.75H51.56v7.13H84.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.47,134H53.79v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.62,134H56.93v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.69,134H60v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.61,134H62.93v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.58,134H65.89v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.58,134H68.9v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.73,134H72.05v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.81,134H75.12v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.72,134H78v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.69,134H81v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.47,138.16H53.79v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.62,138.16H56.93v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.69,138.16H60v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.61,138.16H62.93v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.58,138.16H65.89v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.58,138.16H68.9v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.73,138.16H72.05v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.81,138.16H75.12v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.72,138.16H78v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.69,138.16H81v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.47,142.28H53.79v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.62,142.28H56.93v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.69,142.28H60v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.61,142.28H62.93v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.58,142.28H65.89v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.58,142.28H68.9v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.73,142.28H72.05v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.81,142.28H75.12v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.72,142.28H78v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.69,142.28H81v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.47,126.75H54.06v2.44h1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.5,126.75H68.09v2.44H69.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M80.66,126.75H79.25v2.44h1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.5,127.61v22H20.72l-4-4.29V127.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.5,124.75H16.75v7.13H49.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.67,134H19v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.82,134H22.13v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.89,134H25.2v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.8,134H28.12v2.36H29.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.77,134H31.09v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.78,134H34.1v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.93,134H37.24v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42,134H40.31v2.36H42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.91,134H43.23v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.89,134H46.2v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.67,138.16H19v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.82,138.16H22.13v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.89,138.16H25.2v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.8,138.16H28.12v2.37H29.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.77,138.16H31.09v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.78,138.16H34.1v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.93,138.16H37.24v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42,138.16H40.31v2.37H42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.91,138.16H43.23v2.37h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.89,138.16H46.2v2.37h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.67,142.28H19v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.82,142.28H22.13v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.89,142.28H25.2v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.8,142.28H28.12v2.36H29.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.77,142.28H31.09v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.78,142.28H34.1v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.93,142.28H37.24v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42,142.28H40.31v2.36H42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.91,142.28H43.23v2.36h1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.89,142.28H46.2v2.36h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.67,126.75H19.25v2.44h1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.69,126.75H33.28v2.44h1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.86,126.75H44.45v2.44h1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.62,127.61v13.73a21.37,21.37,0,0,1-1.56-8.23,3.31,3.31,0,0,1,0-.44c0-.27,0-.54,0-.79s0-.46,0-.69c.07-.84.17-1.69.3-2.53,0,0,0,0,0-.08s0-.29.07-.44.07-.35.1-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.62,124.74v7.14H13.09c0-.23,0-.46,0-.69.07-.84.17-1.69.3-2.53,0,0,0,0,0-.08s.05-.29.07-.44.07-.35.11-.53c.12-.63.27-1.25.43-1.89,0-.15.07-.3.11-.45s.1-.35.17-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M315.06,34.14a8.7,8.7,0,0,0-8.71,8.69c0,4.8,8.71,16.9,8.71,16.9s8.72-12.1,8.72-16.9A8.7,8.7,0,0,0,315.06,34.14Zm0,11.67a3.34,3.34,0,1,1,3.35-3.34A3.34,3.34,0,0,1,315.06,45.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M98.18,59.52A16.64,16.64,0,0,0,81.51,76.15c0,9.18,16.67,32.31,16.67,32.31s16.67-23.14,16.67-32.31A16.64,16.64,0,0,0,98.18,59.52Zm0,22.33a6.39,6.39,0,1,1,6.41-6.39A6.41,6.41,0,0,1,98.18,81.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.64,126.19a1.31,1.31,0,0,1-.5-2.53c2.83-1.2,6-3.62,10-7.61a1.32,1.32,0,0,1,1.86,0,1.3,1.3,0,0,1,0,1.86c-4.25,4.24-7.69,6.84-10.85,8.17A1.31,1.31,0,0,1,117.64,126.19Zm-9.23-.43a1.33,1.33,0,0,1-.69-.19c-3.09-1.87-5.9-5.37-8.57-10.68a1.31,1.31,0,0,1,2.35-1.17c2.42,4.79,5,8,7.6,9.61a1.31,1.31,0,0,1-.69,2.43Zm95.85-6.57a1.31,1.31,0,0,1-.27-2.6c4.72-1,8.21-3,10.38-5.87a1.32,1.32,0,0,1,2.11,1.58c-2.57,3.41-6.59,5.72-12,6.86A1.15,1.15,0,0,1,204.26,119.19Zm-9.44-.12a1.36,1.36,0,0,1-.61-.14c-3.21-1.67-6.06-5.2-9.35-10a1.3,1.3,0,0,1,.34-1.83,1.32,1.32,0,0,1,1.83.34c2.66,3.86,5.52,7.63,8.4,9.13a1.31,1.31,0,0,1,.57,1.76A1.33,1.33,0,0,1,194.82,119.07Zm-60.14-7.8a1.27,1.27,0,0,1-.87-.35,1.29,1.29,0,0,1-.1-1.85l1.12-1.25c2.55-2.82,5.18-5.75,7.85-8.46a1.32,1.32,0,0,1,1.88,1.84c-2.63,2.67-5.25,5.57-7.77,8.37l-1.13,1.25A1.29,1.29,0,0,1,134.68,111.27Zm83.81-7.43h-.09a1.31,1.31,0,0,1-1.23-1.39c0-.51.05-1,.05-1.54A39.34,39.34,0,0,0,215.41,90a1.31,1.31,0,0,1,2.52-.75,42,42,0,0,1,1.92,11.69c0,.58,0,1.15,0,1.71A1.32,1.32,0,0,1,218.49,103.84Zm-38-2.27a1.32,1.32,0,0,1-1.07-.56c-2.19-3.06-5.16-6.87-8.62-9.24a1.31,1.31,0,1,1,1.49-2.16c3.79,2.59,6.94,6.64,9.27,9.88a1.3,1.3,0,0,1-.31,1.83A1.22,1.22,0,0,1,180.48,101.57Zm-29.71-6.45a1.31,1.31,0,0,1-.81-2.35,37.22,37.22,0,0,1,6.66-4.24,17.34,17.34,0,0,1,5.72-1.68,1.31,1.31,0,1,1,.26,2.61,14.76,14.76,0,0,0-4.84,1.44,33.75,33.75,0,0,0-6.18,3.94A1.23,1.23,0,0,1,150.77,95.12ZM298.11,84.07c-.45,0-.93,0-1.4,0a21.16,21.16,0,0,1-7.46-1.79,1.32,1.32,0,1,1,1.06-2.41,18.76,18.76,0,0,0,6.55,1.58,19.8,19.8,0,0,0,5.46-.42,1.31,1.31,0,1,1,.59,2.55A21,21,0,0,1,298.11,84.07Zm12.58-5.41a1.28,1.28,0,0,1-.83-.3,1.32,1.32,0,0,1-.18-1.85c2.9-3.5,3.9-8.15,4.23-11.42a1.32,1.32,0,0,1,2.62.26c-.37,3.64-1.5,8.83-4.82,12.84A1.36,1.36,0,0,1,310.69,78.66ZM281.86,77a1.25,1.25,0,0,1-.89-.35,60.51,60.51,0,0,1-8.58-10.31,1.31,1.31,0,0,1,2.18-1.47,58.36,58.36,0,0,0,8.2,9.87,1.31,1.31,0,0,1,.06,1.86A1.39,1.39,0,0,1,281.86,77Zm-13.5-18.28a1.3,1.3,0,0,1-1.14-.65c-2.22-3.84-4.36-7.84-6.35-11.59a1.32,1.32,0,0,1,2.34-1.23c2,3.73,4.1,7.7,6.29,11.5A1.31,1.31,0,0,1,269,58.5,1.24,1.24,0,0,1,268.36,58.68ZM197,39.64a1.32,1.32,0,0,1-1.3-1.12,62.56,62.56,0,0,1-.67-8.8,45.66,45.66,0,0,1,.22-4.61,1.31,1.31,0,0,1,2.61.27,43.22,43.22,0,0,0-.21,4.34,58.87,58.87,0,0,0,.65,8.43,1.31,1.31,0,0,1-1.11,1.49Zm60.59-1a1.31,1.31,0,0,1-1.17-.7c-1.71-3.22-4-7.42-6.39-11.43a1.32,1.32,0,0,1,2.26-1.35c2.44,4.05,4.73,8.3,6.46,11.55a1.31,1.31,0,0,1-.55,1.77A1.21,1.21,0,0,1,257.54,38.61ZM245.84,19a1.33,1.33,0,0,1-1.07-.54A52.73,52.73,0,0,0,236.25,9a1.29,1.29,0,0,1-.15-1.84A1.31,1.31,0,0,1,238,7a55.68,55.68,0,0,1,9,10,1.3,1.3,0,0,1-.29,1.83A1.32,1.32,0,0,1,245.84,19Zm-47-1.8a1.35,1.35,0,0,1-.52-.11,1.32,1.32,0,0,1-.7-1.72A23.21,23.21,0,0,1,206.4,4.9a1.32,1.32,0,0,1,1.82.39,1.3,1.3,0,0,1-.4,1.81A20.54,20.54,0,0,0,200,16.43,1.28,1.28,0,0,1,198.81,17.24ZM228.92,4.33a1.24,1.24,0,0,1-.46-.08,20.29,20.29,0,0,0-11.3-.77l-.86.19a1.32,1.32,0,0,1-.59-2.57l.92-.2a23,23,0,0,1,12.74.89,1.3,1.3,0,0,1,.78,1.68A1.32,1.32,0,0,1,228.92,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.57,73.64a10.93,10.93,0,1,0-11-10.92A10.93,10.93,0,0,0,205.57,73.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M189.79,63.39a15.43,15.43,0,1,1,15.43,15.39A15.42,15.42,0,0,1,189.79,63.39Zm17.49,3.08c0-1.35,0-2.71,0-4.07a2.06,2.06,0,1,0-4.11,0q0,4.1,0,8.17a2.29,2.29,0,0,0,.16.81,2,2,0,0,0,3.94-.76C207.29,69.23,207.27,67.85,207.28,66.47Zm0-10.25a2.06,2.06,0,1,0-2.06,2.05A2,2,0,0,0,207.27,56.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M311.28,124.54c-1.16.67-2.32,1.33-3.48,2l-16.29,9.37-6.65,3.81a2.79,2.79,0,0,1-3.78-.92,2.74,2.74,0,0,1,1.05-3.84l12.9-7.42q8.1-4.67,16.21-9.32a1,1,0,0,0,.57-1q0-18,0-36c0-.23,0-.45,0-.72h18.73c1,0,.95-.16.95.91v60.34c0,.17,0,.33,0,.5s-.13.41-.42.4c-.51,0-1,0-1.51,0s-.62-.13-.62-.61c0-4.32,0-8.64,0-13,0-.2,0-.41-.05-.67-.18.1-.28.14-.38.21-1,.69-1.92,1.39-2.9,2.06a1,1,0,0,0-.49,1c0,3.45,0,6.91,0,10.35a1.32,1.32,0,0,1,0,.4c0,.1-.15.24-.23.24-.61,0-1.23,0-1.88,0,0-.23,0-.42,0-.59,0-.62,0-1.24,0-1.85,0-.38-.11-.55-.51-.53-.57,0-1.14,0-1.7,0s-.52.16-.51.53c0,.67,0,1.33,0,2,0,.34-.13.47-.48.45a8.08,8.08,0,0,0-1.1,0c-.48.05-.58-.16-.58-.6,0-3.48,0-7,0-10.46a.92.92,0,0,0-.45-.86c-1-.68-1.93-1.39-2.89-2.08a3,3,0,0,0-.48-.25V132c0,3.33,0,6.67,0,10,0,.49-.15.65-.63.61s-.83,0-1.25,0c-.66,0-.66,0-.66-.65V124.3A4.72,4.72,0,0,0,311.28,124.54ZM323,97.74c0-.36-.08-.51-.46-.5-.6,0-1.21,0-1.81,0-.35,0-.46.13-.46.48,0,.76,0,1.53,0,2.29,0,.31.09.45.43.45.63,0,1.26,0,1.9,0,.28,0,.39-.1.38-.38s0-.83,0-1.24S323,98.1,323,97.74Zm-2.73,15c0,.32.13.43.46.42.61,0,1.23,0,1.85,0,.29,0,.42-.09.42-.4q0-1.2,0-2.4c0-.3-.13-.41-.42-.4-.62,0-1.24,0-1.85,0-.32,0-.46.1-.45.44s0,.8,0,1.2S320.29,112.36,320.27,112.75ZM323,123.11c0-.29-.09-.43-.4-.43h-1.91c-.3,0-.42.11-.42.41,0,.8,0,1.59,0,2.4,0,.26.1.4.38.4q1,0,2,0c.27,0,.39-.1.38-.38s0-.83,0-1.25S323,123.5,323,123.11ZM320.27,91.5c0,.33.09.49.45.48.61,0,1.24,0,1.85,0,.29,0,.42-.09.42-.4,0-.81,0-1.63,0-2.45,0-.31-.12-.41-.42-.4h-1.85c-.33,0-.46.1-.45.42s0,.8,0,1.2S320.29,91.12,320.27,91.5ZM323,135.78c0-.27-.11-.39-.39-.38h-1.95c-.29,0-.38.13-.38.4q0,1.2,0,2.4c0,.3.12.42.42.42h1.91c.3,0,.4-.14.39-.43s0-.79,0-1.2S323,136.19,323,135.78Zm0-42.34c0-.29-.1-.43-.4-.42-.64,0-1.28,0-1.91,0-.31,0-.41.13-.41.42,0,.8,0,1.61,0,2.4,0,.28.1.4.39.4h1.95c.28,0,.39-.12.39-.39s0-.83,0-1.25S323,93.82,323,93.44Zm-2.72,15.11c0,.28.12.39.39.39h1.95c.28,0,.38-.12.38-.4q0-1.19,0-2.4c0-.3-.12-.41-.42-.4-.63,0-1.26,0-1.91,0-.31,0-.41.14-.4.42s0,.83,0,1.25h0C320.29,107.79,320.3,108.17,320.28,108.55Zm2.72-6.69c0-.26-.1-.37-.35-.37-.67,0-1.33,0-2,0-.29,0-.37.15-.37.4,0,.78,0,1.57,0,2.35,0,.31.1.45.44.44.63,0,1.27,0,1.9,0,.28,0,.39-.11.39-.38s0-.8,0-1.2S323,102.28,323,101.86Zm-2.73,19.28c0,.35.1.53.48.51.6,0,1.21,0,1.8,0,.31,0,.46-.08.45-.42,0-.78,0-1.57,0-2.35,0-.32-.11-.44-.44-.43-.61,0-1.24,0-1.85,0-.33,0-.44.13-.43.45s0,.76,0,1.15S320.3,120.77,320.27,121.14ZM323,131.57c0-.28-.09-.42-.39-.42H320.7c-.29,0-.42.11-.42.42,0,.77,0,1.56,0,2.34,0,.32.1.46.44.45.63,0,1.26,0,1.9,0,.27,0,.4-.11.39-.39s0-.83,0-1.24A11.22,11.22,0,0,1,323,131.57Zm0-3.8c0-.9.13-.84-.87-.84h-1.39c-.31,0-.46.1-.45.43,0,.76,0,1.54,0,2.3,0,.33.1.48.46.47.62,0,1.23,0,1.86,0,.29,0,.42-.11.41-.41s0-.8,0-1.2S323,128,323,127.77Zm0-13.13c0-.29-.08-.42-.39-.42-.64,0-1.27,0-1.9,0-.33,0-.44.13-.43.44,0,.77,0,1.53,0,2.3,0,.34.12.47.47.46.58,0,1.17,0,1.75,0,.41,0,.53-.15.5-.52s0-.73,0-1.1S323,115,323,114.64Zm-38.41,22.77a1.16,1.16,0,0,0-1.17-1.18,1.15,1.15,0,1,0,1.17,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M339,128.47v1c0,4.2,0,8.4,0,12.6,0,.43-.09.61-.55.57a9.35,9.35,0,0,0-1.4,0c-.5,0-.6-.16-.6-.63q0-30.45,0-60.89c0-.5.11-.65.64-.65q9.24,0,18.47,0c.51,0,.64.13.63.64q0,30.42,0,60.85c0,.09,0,.2,0,.3,0,.28-.12.38-.39.38h-1.46c-.72,0-.72,0-.72-.7V129c0-.19,0-.38,0-.63-.2.11-.32.17-.42.24-.93.66-1.84,1.34-2.78,2a1.13,1.13,0,0,0-.55,1.07c0,3.47,0,6.94,0,10.41,0,.4-.1.58-.53.55a8.83,8.83,0,0,0-1.15,0c-.36,0-.53-.09-.5-.47s0-.8,0-1.2c0-1.31,0-1.31-1.34-1.31s-1.37,0-1.38,1.39c0,.5.15,1.2-.12,1.44s-1,.1-1.48.15-.56-.12-.56-.56c0-3.12-.06-6.24,0-9.36a2.53,2.53,0,0,0-1.37-2.68,21.13,21.13,0,0,1-2.32-1.63Zm6.11-36.61c.24.26.94.11,1.43.11,1.14,0,1.14,0,1.14-1.12,0-.53,0-1.07,0-1.59s-.1-.55-.51-.53c-.58,0-1.17,0-1.75,0-.34,0-.49.12-.47.47s0,.79,0,1.2h-.05C345,90.9,344.82,91.56,345.1,91.86Zm0,21.19c.24.26.94.12,1.44.12,1.14,0,1.14,0,1.14-1.14,0-.55,0-1.1,0-1.65,0-.3-.11-.42-.41-.42-.64,0-1.28,0-1.91,0-.31,0-.42.12-.41.42s0,.8,0,1.2h-.05C345,112.09,344.82,112.76,345.1,113.05Zm2.57-6.89c0-.33-.13-.44-.45-.43-.61,0-1.24,0-1.85,0-.29,0-.43.09-.42.41q0,1.19,0,2.4c0,.3.14.4.43.4.61,0,1.24,0,1.85,0,.36,0,.47-.15.45-.48s0-.77,0-1.15A11,11,0,0,1,347.67,106.16Zm0-4.24c0-.3-.1-.43-.4-.42-.64,0-1.27,0-1.91,0-.29,0-.42.1-.42.41,0,.8,0,1.59,0,2.4,0,.26.08.4.38.39.65,0,1.29,0,1.94,0,.28,0,.4-.1.39-.38s0-.8,0-1.2S347.65,102.31,347.67,101.92Zm-2.73,19.3c0,.29.1.43.4.43q1,0,2,0c.28,0,.38-.13.38-.4,0-.79,0-1.59,0-2.39,0-.25-.08-.4-.38-.4q-1,0-2,0c-.31,0-.4.14-.39.43s0,.76,0,1.15S345,120.82,344.94,121.22Zm2.73-23.57c0-.3-.12-.41-.42-.4q-.93,0-1.86,0c-.3,0-.45.11-.45.44,0,.78,0,1.57,0,2.35,0,.32.13.43.45.42h1.85c.3,0,.43-.1.42-.41s0-.79,0-1.2S347.66,98.06,347.67,97.65Zm0-4.21c0-.29-.11-.43-.41-.43h-1.91c-.31,0-.41.14-.41.43,0,.79,0,1.59,0,2.39,0,.27.1.4.39.4h1.94c.28,0,.4-.12.39-.39s0-.79,0-1.2S347.66,93.84,347.67,93.44Zm-2.57,40.8c.24.25.9.11,1.38.12,1.19,0,1.19,0,1.19-1.19,0-.54,0-1.06,0-1.6,0-.29-.12-.42-.41-.41-.65,0-1.3,0-1.95,0a.5.5,0,0,0-.35.34c0,.43,0,.86,0,1.3h-.06C345,133.31,344.83,134,345.1,134.24Zm2.56,1.54c0-.28-.11-.39-.39-.39-.64,0-1.28,0-1.91,0-.3,0-.42.11-.42.41q0,1.2,0,2.4c0,.26.1.41.38.41.65,0,1.3,0,1.95,0,.31,0,.4-.16.39-.44s0-.79,0-1.19Zm0-12.73a.52.52,0,0,0-.34-.34,16.68,16.68,0,0,0-2,0,.51.51,0,0,0-.34.36c0,.81,0,1.62,0,2.44,0,.27.11.39.38.38q1,0,1.95,0c.28,0,.38-.13.38-.4s0-.8,0-1.2A10.26,10.26,0,0,0,347.64,123.05Zm-2.7,6.64c0,.29.1.43.4.43.65,0,1.3,0,2,0a.49.49,0,0,0,.34-.34c0-.83,0-1.66,0-2.49,0-.27-.13-.34-.38-.34h-1.9c-.37,0-.47.15-.45.48s0,.73,0,1.09A11.81,11.81,0,0,1,344.94,129.69Zm.16-12.41c.24.26.94.11,1.44.11,1.14,0,1.14,0,1.14-1.13,0-.53,0-1.06,0-1.6,0-.3-.1-.46-.43-.45-.64,0-1.27,0-1.91,0-.28,0-.39.1-.38.38v1.2h0C345,116.31,344.82,117,345.1,117.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M289.61,129.21h-.56c-4.41,0-8.83,0-13.25,0-.52,0-.63.18-.63.66,0,4.44,0,8.87,0,13.3,0,.65,0,.66-.66.66-2.63,0-55.43.61-55.43.61v5.25l46.7.32h93.1c.64,0,.64,0,.64-.65,0-1.37,0-2.74,0-4.11,0-1.06-.35-1.41-1.42-1.41H292.33c-1.1,0-.94,0-.94-.94,0-1.7,0-3.4,0-5.1,0-.11,0-.22-.05-.4L288.48,139c-1,.6-2.08,1.21-3.13,1.8a3.94,3.94,0,0,1-5.85-3.65,4.06,4.06,0,0,1,2.31-3.4c2.49-1.4,5-2.84,7.43-4.26A4.62,4.62,0,0,0,289.61,129.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M267.79,110.66c0-.48.13-.62.61-.62,2.61,0,5.23,0,7.83,0h21.89c.42,0,.67,0,.66.57,0,4.32,0,8.64,0,13a.68.68,0,0,1-.39.67c-2,1.16-4.08,2.35-6.13,3.51a2.24,2.24,0,0,1-1,.27c-5.5,0-11,0-16.51,0-.72,0-.72,0-.72.75,0,4.42,0,8.84,0,13.26,0,.47-.14.6-.6.59-1.64,0-3.28,0-4.91,0-.69,0-.69,0-.69-.69V126.37C267.8,121.13,267.81,115.9,267.79,110.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M263.49,108.86h38.85c.77,0,.78,0,.78-.75,0-3,0-5.9,0-8.86,0-.49-.17-.57-.6-.57h-38.4c-.66,0-.66,0-.66.65v9C263.46,108.46,263.48,108.63,263.49,108.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M298.73,133.12c-1.76,1-3.43,2-5.16,2.94a1.66,1.66,0,0,0-1,1.82c.09,1.41,0,2.82,0,4.24,0,.4.14.52.52.51q2.61,0,5.22,0c.32,0,.48-.08.48-.44q0-4.4,0-8.79A1.14,1.14,0,0,0,298.73,133.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M280.22,115.58c0-.37-.09-.54-.5-.53-1.05,0-2.11,0-3.16,0-.32,0-.46.09-.46.43,0,1.08,0,2.16,0,3.24,0,.31.12.42.41.42,1.09,0,2.17,0,3.26,0,.33,0,.44-.14.43-.46,0-.53,0-1.07,0-1.6S280.2,116.08,280.22,115.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M286.37,118.67c0,.3.08.47.42.47,1.09,0,2.17,0,3.26,0,.29,0,.4-.13.4-.43,0-1.08,0-2.16,0-3.24,0-.31-.13-.41-.41-.41h-3.26c-.31,0-.42.12-.41.42v1.64C286.37,117.64,286.38,118.15,286.37,118.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M281.24,118.63c0,.36.11.51.49.51,1,0,2.11,0,3.16,0,.37,0,.46-.15.45-.48q0-1.58,0-3.15c0-.36-.13-.45-.48-.45-1.05,0-2.1,0-3.16,0-.35,0-.47.14-.46.47,0,.52,0,1,0,1.55S281.26,118.11,281.24,118.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M291.5,118.72c0,.31.12.42.41.42h3.26c.29,0,.41-.12.41-.42v-3.24c0-.3-.1-.41-.41-.41h-3.26c-.31,0-.41.12-.4.42,0,.53,0,1.06,0,1.6S291.52,118.17,291.5,118.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M274.67,119.13c.29,0,.43-.09.43-.41,0-1.08,0-2.17,0-3.24,0-.29-.09-.42-.41-.42h-3.26c-.29,0-.43.08-.43.4,0,1.08,0,2.17,0,3.25,0,.3.12.42.42.42h3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M326.32,82.62c-.36,0-.52.11-.51.49,0,.63,0,1.26,0,1.9,0,.33.11.48.46.48.89,0,1.78,0,2.66,0,.3,0,.42-.12.42-.41,0-.69,0-1.37,0-2,0-.31-.14-.41-.43-.4-.45,0-.91,0-1.35,0S326.74,82.64,326.32,82.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M314.39,82.62c-.32,0-.46.11-.45.43,0,.65,0,1.3,0,2,0,.33.11.48.47.48.88,0,1.77,0,2.66,0,.29,0,.42-.12.42-.41,0-.69,0-1.37,0-2,0-.32-.14-.41-.43-.4-.45,0-.91,0-1.36,0S314.82,82.64,314.39,82.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M324.9,85.48c.3,0,.44-.1.44-.4,0-.69,0-1.37,0-2,0-.29-.12-.41-.42-.41-.87,0-1.74,0-2.6,0-.29,0-.44.08-.43.4v2c0,.29.11.42.41.41s.87,0,1.3,0S324.48,85.47,324.9,85.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M318.31,82.65A.52.52,0,0,0,318,83c0,.7,0,1.4,0,2.1,0,.27.12.4.39.39.9,0,1.81,0,2.71,0a.48.48,0,0,0,.35-.35c0-.72,0-1.44,0-2.15a.5.5,0,0,0-.37-.32c-.45,0-.91,0-1.36,0S318.76,82.61,318.31,82.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M339.07,82.62c-.32,0-.47.1-.46.43,0,.67,0,1.33,0,2,0,.32.13.44.46.44.86,0,1.73,0,2.59,0,.35,0,.5-.11.48-.46,0-.65,0-1.29,0-1.94,0-.35-.13-.47-.48-.46s-.86,0-1.3,0S339.5,82.64,339.07,82.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M353.62,85.48c.28,0,.39-.11.39-.39,0-.7,0-1.4,0-2.09,0-.28-.13-.38-.4-.38h-2.7c-.3,0-.42.12-.42.42q0,1,0,2c0,.31.14.42.43.41h1.35C352.72,85.48,353.17,85.47,353.62,85.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M349.56,85.48c.3,0,.46-.1.46-.43,0-.67,0-1.33,0-2,0-.28-.08-.42-.4-.42H347c-.32,0-.41.14-.41.42v2c0,.28.11.39.39.39.45,0,.91,0,1.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M345.66,85.48c.31,0,.41-.12.4-.42,0-.68,0-1.37,0-2,0-.28-.1-.39-.38-.39H343c-.31,0-.42.12-.41.42q0,1,0,2c0,.28.11.4.39.39.45,0,.9,0,1.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M366.63,150H2.57a.36.36,0,0,1-.36-.36v-.12a.36.36,0,0,1,.36-.36H366.63a.36.36,0,0,1,.36.36v.12A.36.36,0,0,1,366.63,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M362.47,149.68H351.94c-.56-.47.39-1.55,1.39-1.63a6,6,0,0,1,1.61.19c.14-1.92,1-10.54,4.09-10.19,3.5.39,0,3.8-1,5.81a47,47,0,0,0-1.86,4.65l.87.18c.47-1.42,2.2-6.21,4.39-5.93,2.58.33,1.55,2.24-.29,3.38-1.34.84-3,2-3.77,2.6a12.6,12.6,0,0,0,2.05.17A4.51,4.51,0,0,1,362.47,149.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4.9,148.71c-.49-.77-2-2.78-4-2.52-2.16.29,2.39,1.71,3.77,2.52a2.49,2.49,0,0,1-.77-.08c-.93-.34-2.52.3-3,.52H9.76a1.39,1.39,0,0,0-.63-.8,1.48,1.48,0,0,0-.82-.07c.53-.63.9-2.6-.57-2.09-1.07.37-1.07,1.58-1,2.3l-.69.1c-.44-2.24-2-8.8-5.16-9s2.71,6.81,4.69,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M10.53,149.68s3-9,11.65-10.68,15,5,22.69,2.38,19.8-16.52,34.22-6.37,13.47,13.05,22.56,10.67,11.18,4,11.18,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M19.39,141.26s-6.29-6.58-9.51-4.82S19.39,141.26,19.39,141.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M17.79,142.92S12,141,10.53,142,17.79,142.92,17.79,142.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.24,142.32s4-8.92,5.36-7.3S36.24,142.32,36.24,142.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.26,141.71s1.63-6.53-.81-6.12S35.26,141.71,35.26,141.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeliveryPlaceholder);
export default __webpack_public_path__ + "static/media/no-delivery-placeholder.d64ef2c08da665a494f152884af956a0.svg";
export { ForwardRef as ReactComponent };